import { apiClientes } from "../../config/api";
import { RetornaAceiteTermoResponse } from "../../interfaces/entities/RetornaAceiteTermoResponse";
import { Diario } from "../../interfaces/entities/UnimedAcolhe/Diario";
import { HistoricoMeuDiario } from "../../interfaces/entities/UnimedAcolhe/HistoricoMeuDiario";
import { MeuDiarioQuestoes } from "../../interfaces/entities/UnimedAcolhe/MeuDiarioQuestoes";
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";

export const getDiario = async (): Promise<Diario | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetDiario', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getHistoricDataDiario = async (): Promise<HistoricoMeuDiario[] | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetHistoricoDataDiario', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getHistoricoDiarioById = async (idRespQuestBenef: string): Promise<MeuDiarioQuestoes[] | null> => {
    try {
        const response = await apiClientes.get(`SaudeEmocional/GetHistoricoDiario/?id=${idRespQuestBenef}`, {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getMostrarNovamenteDiario = async (): Promise<RetornaAceiteTermoResponse | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetMostrarNovamenteDiario', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getDiarioQuestoes = async (): Promise<MeuDiarioQuestoes[] | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetDiarioQuestoes', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const salvarRespostaQuestionario = (payload: MeuDiarioQuestoes[]): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.post("SaudeEmocional/SalvarRespostaQuestionario",
				payload,
				{ headers });

			if (response?.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}


